<template>
  <div>
    <custom-table
      :tableHeader="tableHeader"
      :page="api.page"
      @next="handleNextPage()"
      @prev="handlePrevPage()"
    >
      <template v-if="items.length > 0 && !loaders.page">
        <tr v-for="(item, i) in items" :key="i">
          <td>{{ item.name }}</td>
          <td>{{ item.address }}</td>
          <td class="table__content-action">
            <action-button
              label=""
              style="margin-right: 15px; margin-top: 0;"
              @customEvent="handleClickEdit(item)"
            >
              <img src="~@/assets/media/icons/create-light.svg" alt="edit icon"
            /></action-button>
            <action-button
              label=""
              :disabled="
                !!(
                  item.ProductCollections && item.ProductCollections.length > 0
                )
              "
              :class="[
                'btn--remove position-relative',
                {
                  'disabled--btn': !!(
                    item.ProductCollections &&
                    item.ProductCollections.length > 0
                  )
                }
              ]"
              style="margin-right: 0; margin-top: 0;"
              @customEvent="handleClickDelete(item)"
            >
              <div class="tooltipText">
                <p>To delete location, please delete linked products</p>
              </div>
              <FetchingOverlay v-if="loaders.deleteButton === item.id" />
              <span v-else>
                &mdash;
              </span>
            </action-button>
          </td>
        </tr>
      </template>
      <tr v-else-if="loaders.page">
        <td colspan="5">
          <Spinner :theme="primary" />
        </td>
      </tr>
      <tr v-else>
        <td colspan="5">
          No Locations found...
        </td>
      </tr>
    </custom-table>
  </div>
</template>

<script>
import FetchingOverlay from "@/components/FetchingOverlay";
import ActionButton from "@/components/ActionButton";
import Spinner from "@/components/Spinner";
import CustomTable from "../CustomTable";
import { locations } from "../../helpers/table-headers";
import { socketSender } from "@/helpers/socket";
import { mapActions, mapGetters } from "vuex";
import axios from "@/helpers/axios";

export default {
  components: {
    ActionButton,
    CustomTable,
    Spinner,
    FetchingOverlay
  },
  data: () => ({
    tableHeader: [],
    api: {
      page: 1,
      size: 10,
      action: "orderBy=id:DESC"
    },
    loaders: {
      page: true,
      deleteButton: -1
    }
  }),
  created() {
    this.init();
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    user() {
      return this.$store.getters.getFullUser;
    },
    items: {
      get() {
        return this.GET_COLLECTION();
      }
    }
  },
  methods: {
    ...mapActions({
      FETCH_COLLECTION_PER_PAGE: "FETCH_COLLECTION_PER_PAGE"
    }),
    ...mapGetters({
      GET_COLLECTION: "GET_COLLECTION"
    }),
    init() {
      this.tableHeader = locations;
      this.handleReloadPage();
    },
    handleClickEdit(item) {
      const { page, size, action } = this.api;
      this.$emit("edit", {
        singleRecord: item,
        link: this.pagelink(page, size, action)
      });
    },
    async handleClickDelete(item) {
      if (item.ProductCollections && item.ProductCollections.length > 0) return;
      this.loaders.deleteButton = item.id;
      const orders = await axios
        .get(`/products?locationId=${item.id}`)
        .then(result => {
          const { data } = result.data;
          return data;
        });

      this.loaders.deleteButton = -1;
      if (orders.length === 0) {
        this.$swal({
          title: "Are you sure to remove this data",
          type: "warning",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true
        }).then(async result => {
          if (result.value) {
            await axios.delete(`/locations/${item.id}`);
            socketSender(
              "updateLog",
              `${this.user} removed the location named ${item.name}`
            );
            await this.handleReloadPage();
          }
        });
      } else {
        this.$swal({
          title:
            "Can't delete this location entry since it is associated with active records.",
          type: "error"
        });
      }
    },
    async handleReloadPage() {
      const { page, size, action } = this.api;
      await this.FETCH_COLLECTION_PER_PAGE(this.pagelink(page, size, action));
      this.loaders.page = false;
    },
    handleNextPage() {
      this.api.page += 1;
      this.loaders.page = true;
      this.handleReloadPage();
    },
    handlePrevPage() {
      this.api.page -= 1;
      this.loaders.page = true;
      this.handleReloadPage();
    },
    pagelink(page, size = 10, action = "") {
      return `/locations?page[number]=${page}&page[size]=${size}&${action}`;
    }
  }
};
</script>

<style lang="scss">
.btn--remove {
  background-color: #fa533d !important;
}

.tooltipText {
  z-index: 10;
  opacity: 0;
  content: "";
  visibility: hidden;
  transition: 300ms;
  position: absolute;
  background: #4c4c4c;
  width: 180px;
  height: auto;
  border-radius: 5px;
  top: 40px;
  right: -78px;
  padding: 4px 12px;
  p {
    white-space: normal;
    text-align: start;
    font-size: 12px;
    margin-bottom: 0;
  }
}

.disabled--btn {
  background: #b7b7b7 !important;
  opacity: 1 !important;
  &:after {
    opacity: 0;
    content: "";
    visibility: hidden;
    transition: 300ms;
    position: absolute;
    border-style: solid;
    border-color: transparent transparent #4c4c4c transparent;
    border-width: 8px;
    top: 25px;
    left: 4px;
  }

  &:hover {
    .tooltipText,
    &:after {
      opacity: 1;
      visibility: visible;
    }
  }
}
</style>
